import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteProfitCenters,
  getComapanyId,
  getCompanys,
  getProfitCenter,
  insertProfitCenters,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function Profitcenter() {
  const UID = getSecureItem("userId");
  const [addProfitCenterModal, setAddProfitCenterModal] = useState(false);
  const [editProfitCenterModal, setEditProfitCenterModal] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profitCenters, setProfitCenters] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [companyDatas, setCompanyDatas] = useState([]);
  const [deleteProfitCenterId, setDeleteProfitCenterId] = useState(null); // Store the ID to be deleted
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [profitCenterData, setProfitCenterData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    CompanyId: "",
    UserId: UID,
  });

  const openAddProfitCenterModal = () => {
    clearData();
    setProfitCenterData({});
    setAddProfitCenterModal(!addProfitCenterModal);
  };
  const openEditProfitCenterModal = (data) => {
    console.log("data", data);

    const CommonDataName = companyDatas.find((item) => {
      console.log(companyDatas, "cr");

      if (item.Id == data?.CompanyId) {
        return item?.Name;
      }
    });
    console.log("CommonDataName", CommonDataName);

    setEditProfitCenterModal(!editProfitCenterModal);

    setProfitCenterData({
      ...data,
      Company: CommonDataName?.Name,
      UserId: UID || "",
    });
  };

  const clearData = () => {
    setProfitCenterData({
      Id: "",
      Name: "",
      Narration: "",
      CompanyId: "",
      UserId: UID,
    });
  };
  const clearDataForEdit = () => {
    setProfitCenterData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      CompanyId: "",
      UserId: UID, // Assuming UID is a variable or state you have defined
    }));
  };

  const fetchProfitCenters = async () => {
    try {
      const data = await getProfitCenter(UID);
      console.log(data.data.data, "Fetched data");
      setProfitCenters(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching profitCenters", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfitCenterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openModal = (ProfitCenterId) => {
    setDeleteProfitCenterId(ProfitCenterId); // Store the ProfitCenter ID
    setIsModalOpen(true); // Open the modal
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    setDeleteProfitCenterId(null); // Clear the stored ID
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    console.log("FGFG", deleteProfitCenterId);

    if (deleteProfitCenterId) {
      handleDelete(deleteProfitCenterId); // Call handleDelete with the stored ID
    }
    closeModal(); // Close the modal after confirming
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertProfitCenters(profitCenterData);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchProfitCenters();
        openAddProfitCenterModal();
      }
      // Close the modal
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name or Code")) {
        toast.error("This Profit Center already exist");
      } else {
        toast.error("This Profit Center already exist");
      }
      console.error("Error adding Profit Centers:", error);
    } finally {
      setLoading(false);
    }
  };
  // edit
  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertProfitCenters(profitCenterData);
      if (response.data.StatusCode === 200) {
        toast.success(
          response.data?.message || "Profit center updated successfully!"
        );
        fetchProfitCenters();
        openEditProfitCenterModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name or Code")) {
        toast.error("The code or Name is already in use. Please use a  and Name");
      } else {
        toast.error("Error occurred while editing Profit Center.");
      }
    } finally {
      setLoading(false);
    }
  };

  // remove
  const handleDelete = async (ProfitCenterId) => {
    const removeData = { Id: ProfitCenterId, TableName: "ProfitCenter" };

    try {
      const res = await deleteProfitCenters(removeData, UID);

      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Profit Center deleted successfully");
          fetchProfitCenters(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Profit Center");
      }
    } catch (error) {
      // Check for specific error status and handle gracefully
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Profit Center.";
        toast.error("Profit center already using cannot delete");
      } else {
        console.error("Error removing Profit Center:", error);
        toast.error("Error deleting Profit Center. Please try again.");
      }
    }
  };

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Profitcenter Name",
      selector: (row) => row.Name,
      sortable: true,
    },
    
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditProfitCenterModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];
  const filteredItems = dataFilter.filter((item) => {
    const companyName =
      companyDatas?.find((el) => el.Id === item.CompanyId)?.Name?.toLowerCase() || "n/a";
  
    return (
      item.Name?.toLowerCase().includes(filterText.toLowerCase()) ||
      (item.Code?.toString().toLowerCase().includes(filterText.toLowerCase())) || // Ensure it's a string
      item.Narration?.toLowerCase().includes(filterText.toLowerCase()) ||
      companyName.includes(filterText.toLowerCase())
    );
  });
  

  const subHeaderComponentMemo = useMemo(() => {
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    console.log("profitCenterData", profitCenterData);
  }, [profitCenterData]);

  useEffect(() => {
    setLoading(true);
    fetchProfitCenters();
  }, []);

  const getCompanyName = (companies, companyId) => {
    const company = companies.find((cat) => cat.Id === companyId);
    return company ? company.Name : ""; // Return the name if found, else return an empty string
  };

  useEffect(() => {
    const fetchCompanyDatas = async () => {
      try {
        const response = await getCompanys(UID);

        setCompanyDatas(response.data.data);
        console.log(companyDatas, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchCompanyDatas();
  }, []);

  useEffect(() => {
    if (profitCenters && profitCenters.length > 0) {
      const updatedData = profitCenters.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        // CommonDataId: item.CompanyId || "",
        CompanyId: item.CompanyId || "",
        Company:
          companyDatas.find((company) => company.Id === item.CompanyId)?.Name ||
          "",
        UserId: item.UserId || "",
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [profitCenters]);



  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };



  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Profit Center?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete} // Confirm the deletion
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    
    <div className="flex items-center justify-between mb-8">
  <Breadcrumb title="Profit Center"  />
  {/* Action Area */}
  <div className="flex items-center gap-4">
    {/* Search and Clear Buttons */}
    <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
      <button
        className="bg-sky rounded-[4px] px-10 py-[8px]"
        onClick={handleFilterClick}
      >
        <IconFilter className="text-white w-[18px] h-[18px]" />
      </button>
      <div className="relative">
        <input
          type="text"
          id="search"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Search by ProfitCenter/Company/Code"
          className="w-[350px] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        
      </div>
      

      <button
        onClick={handleClear}
        className="btn btn-danger"
      >
        Clear
      </button>
    </div>

    {/* Add New Button */}
    <button
      onClick={openAddProfitCenterModal}
      className="btn btn-primary"
    >
      Add New
    </button>
  </div>
</div>

      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={profitCenters} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>

      </div>

      {/* ========================================================Add======================================================== */}

      {addProfitCenterModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Profit Center
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openAddProfitCenterModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col ">
                      <label>
                        ProfitCenter Name <span className="text-red-500"> *</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        required
                        name="Name"
                        placeholder="Name"
                        value={profitCenterData.Name}
                        onChange={handleChange}
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                 
                  
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Company <span className="text-red-500"> *</span>
                      </label>

                      <select
                        name="CompanyId"
                        value={profitCenterData.CompanyId}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Company</option>
                        {companyDatas.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={profitCenterData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            // onClick={openAddProfitCenterModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ========================================================EDIT======================================================== */}

      {editProfitCenterModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Profit Center
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openEditProfitCenterModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        ProfitCenter Name <span className="text-red-500"> *</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={profitCenterData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                 
                  
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Company <span className="text-red-500"> *</span>
                      </label>
                      <select
                        name="CompanyId"
                        value={profitCenterData.CompanyId}
                        onChange={handleChange}
                        required
                      >
                        <option key="" value="">
                          {companyDatas.Id}
                        </option>
                        {companyDatas.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={profitCenterData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            // onClick={openEditProfitCenterModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          >
            {" "}
          </div>
        </>
      )}
    </>
  );
}
